module.exports = __webpack_public_path__ + "static/media/4D.72d20001.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/4D.svg
// module id = 62
// module chunks = 0